import { createAsyncThunk } from '@reduxjs/toolkit';

import axios from 'axios';
import Constants from '../utils/constants';

export const fetchCarTrack = createAsyncThunk(
  'geovideo/fetchCarTrack',
  async ( carTrackId ) => {
    let request = `${Constants.API_BASE_URL}/geovideo/fetchCarTrack/${carTrackId}`;
    try {
      const response = await axios.get(request);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data);
    }
  }
);
